import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import BottomNav from "../components/Layout/BottomNav";
import activityTracker from "../services/ActivityTracker";

/**
 * Main layout component with header, content area, footer, and mobile bottom nav
 */
const MainLayout: React.FC = () => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:767px)');

  // Track page views on route change
  React.useEffect(() => {
    activityTracker.trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <Box
        component="main"
        className="content-container"
        sx={{
          flexGrow: 1,
          px: isMobile ? 1 : 3,
          py: isMobile ? 2 : 4,
          // Add bottom padding on mobile so content isn't hidden behind BottomNav
          pb: isMobile ? 12 : 4,
          display: "flex",
          flexDirection: "column",
          width: '100%',
        }}
      >
        <Outlet />
      </Box>
      <Footer />
      <BottomNav />
    </Box>
  );
};

export default MainLayout;
